<template>
  <div class="page page__has-bar">
    <div class="page__bd">
      <custom-layout class="weui-cells" :view-config="customViewConfig">
        <div class="weui-cell" slot="pi_class">
          <div class="weui-cell__hd">
            <label for class="weui-label">单据类型</label>
          </div>
          <div class="weui-cell__bd">{{ '库存初始化' }}</div>
        </div>
        <date-field
          slot="pi_date"
          :label="customLabel.pi_date || '单据日期'"
          v-model="form.main.pi_date"
        />
        <warehouse-field
          slot="pi_whname"
          v-model="form.main.pi_whname"
          @select="onSelectWarehouse($event, form.main)"
          :label="customLabel.pi_whname || '仓库'"
        />
      </custom-layout>
      <div
        class="weui-cells__group"
        v-for="(item, xindex) in form.items"
        :key="xindex"
      >
        <div class="weui-cells__title">
          <span>物料{{ xindex + 1 }}</span>
          <a
            href="javascript:;"
            class="header-tool"
            @click="removeItem(xindex)"
          >
            <span>删除</span>
          </a>
        </div>
        <div class="weui-cells">
          <custom-layout :view-config="customViewConfig" position="detail1">
            <product-field
              slot="pr_detail"
              :label="customLabel.pr_detail || '物料名称'"
              v-model="item.pr_detail"
              @select="onSelectProduct($event, item)"
            />
            <div class="weui-cell" slot="pd_inqty">
              <div class="weui-cell__hd">
                <label for class="weui-label">{{
                  '数量'
                }}</label>
              </div>
              <div class="weui-cell__bd">
                <input
                  class="weui-input"
                  type="number"
                  v-model="item.pd_inqty"
                  placeholder="0"
                />
              </div>
            </div>
            <div class="weui-cell" slot="pd_madein">
              <div class="weui-cell__hd">
                <label for class="weui-label">{{
                  '产地'
                }}</label>
              </div>
              <div class="weui-cell__bd">
                <input
                  class="weui-input"
                  type="text"
                  v-model="item.pd_madein"
                />
              </div>
            </div>
            <div class="weui-cell" slot="pd_batchcode">
              <div class="weui-cell__hd">
                <label for class="weui-label">{{
                  '批次号'
                }}</label>
              </div>
              <div class="weui-cell__bd">
                <input
                  class="weui-input"
                  type="text"
                  v-model="item.pd_batchcode"
                />
              </div>
            </div>
            <date-field
              slot="pd_madetime"
              :label="customLabel.pd_madetime || '生产日期'"
              v-model="form.main.pd_madetime"
            />
            <div class="weui-cell" slot="pd_shelflife">
              <div class="weui-cell__hd">
                <label for class="weui-label">{{
                  customLabel.pd_shelflife || "保质期（天）"
                }}</label>
              </div>
              <div class="weui-cell__bd">
                <input
                  class="weui-input"
                  type="number"
                  v-model="item.pd_shelflife"
                  placeholder="0"
                />
              </div>
            </div>
            <!-- <div class="weui-cell" slot="apd_qty">
              <div class="weui-cell__hd">
                <label for class="weui-label">{{
                  customLabel.apd_qty || "辅助数量"
                }}</label>
              </div>
              <div class="weui-cell__bd">
                <input
                  class="weui-input"
                  type="number"
                  v-model="item.apd_qty"
                  placeholder="0"
                />
              </div>
            </div> -->
            <div class="weui-cell" slot="pd_price">
              <div class="weui-cell__hd">
                <label for class="weui-label">{{
                  customLabel.pd_price || "成本单价（不含税）"
                }}</label>
              </div>
              <div class="weui-cell__bd">
                <input
                  class="weui-input"
                  type="number"
                  v-model="item.pd_price"
                  placeholder="0"
                />
              </div>
            </div>
            <div class="weui-cell" slot="pd_remark">
              <div class="weui-cell__hd">
                <label for class="weui-label">{{
                  customLabel.pd_remark || "备注"
                }}</label>
              </div>
              <div class="weui-cell__bd">
                <input
                  class="weui-input"
                  type="text"
                  v-model="item.pd_remark"
                />
              </div>
            </div>
          </custom-layout>
          <a
            href="javascript:"
            v-if="xindex == form.items.length - 1"
            class="weui-cell weui-cell_link"
            @click="addItem"
          >
            <div class="weui-cell__bd">添加更多</div>
          </a>
        </div>
      </div>
    </div>
    <div class="footer-bar weui-dialog__ft">
      <a
        href="javascript:;"
        class="weui-dialog__btn weui-dialog__btn_primary"
        @click="save"
        >提交</a
      >
      <a
        href="javascript:;"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="$router.back()"
        >取消</a
      >
    </div>
  </div>
</template>

<script>
import CustomLayout from "@/components/layout/CustomLayout.vue";
import DateField from "@/components/field/DateField.vue";
import WarehouseField from "@/components/field/WarehouseField.vue";
import ProductField from "@/components/field/ProductField.vue";
import process from "@/mixins/process.js";

export default {
  components: {
    CustomLayout,
    DateField,
    WarehouseField,
    ProductField,
  },
  mixins: [process],
  data() {
    return {
      baseUrl: "/api/storage/prodinout",
      codeField: "pi_inoutno",
      statusField: "pi_statuscode",
      caller: "ProductInit",
      xtype: "stock-productinit-formpanel",
      form: {
        main: {

        },
        items: [
          {

          },
        ],
      }
    };
  },
  methods: {
    /**
     * 选择仓库
     */
    onSelectWarehouse(selection, main) {
      main.pi_whid = selection.id;
      main.pi_whcode = selection.wh_code;
    },
    onSelectProduct(selection, item) {
      item.pr_detail = selection.pr_detail;
      item.pd_prodcode = selection.pr_code;
      item.pd_prodid = selection.id;
      item.productDTO = selection
    },
    removeItem(index) {
      var me = this,
        items = me.form.items;
      if (items.length == 1) {
        me.$weui.topTips("请至少保留一行", 2000);
        return;
      } 
      me.f_deleteDetail(items[index].id, function () {
        items.splice(index, 1);
      });
      
    },
    addItem() {
      var me = this,
        items = me.form.items;
      items.push({

      });
    },
    save() {
      var me = this,
        main = me.form.main,
        items = me.form.items,
        checked;
      if (!main.pi_date) {
        me.$weui.topTips("请选择日期", 2000);
      } else if (!main.pi_whname) {
        me.$weui.topTips("请选择仓库", 2000);
      } else {
        var count = 0;
        items.forEach(function (item) {
          if (!item.pd_inqty) {
            me.$weui.topTips(`第${count + 1}行数量未填写`, 2000);
            return false;
          } else if (!item.pr_detail) {
            me.$weui.topTips(`第${count + 1}行物料未选择`, 2000);
            return false;
          } else {
            count++;
            item.pd_pdno = count;
            item.pd_total = item.pd_inqty * (item.pd_price || 0)
          }
        });
        checked = count == items.length;
      }

      if (checked) {
        me.p_save();
      }
    },
  },
};
</script>